/* ==========================================================================
   AJ FITS — Article page
   Reading progress bar and copy-link sharing.
   ========================================================================== */
(function () {
  'use strict';

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  function initProgress() {
    var bar = $('[data-aj-reading-bar]');
    var body = $('[data-aj-article-body]');
    if (!bar || !body) return;

    var ticking = false;

    function update() {
      var rect = body.getBoundingClientRect();
      var total = rect.height - window.innerHeight;
      // Short articles never scroll — leave the bar empty rather than full
      var progress = total > 0 ? (-rect.top / total) : 0;
      progress = Math.min(Math.max(progress, 0), 1);
      bar.style.transform = 'scaleX(' + progress + ')';
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }, { passive: true });

    window.addEventListener('resize', update);
    update();
  }

  function initCopyLink() {
    $$('[data-aj-copy-link]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var url = btn.dataset.url || window.location.href;
        if (navigator.share) {
          navigator.share({ title: document.title, url: url }).catch(function () {});
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(url).then(function () {
            if (window.AJ && window.AJ.toast) window.AJ.toast('Link copied');
          });
        }
      });
    });
  }

  function boot() {
    initProgress();
    initCopyLink();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
